import { ReactNode } from 'react'

export interface AnalyticsDashboardLayoutProps {
  children?: ReactNode
  periodSelector?: ReactNode
  metrics?: ReactNode
  planVsFact?: ReactNode
  funnel?: ReactNode
  charts?: ReactNode
  dailyTable?: ReactNode
  afterTable?: ReactNode
  outerClassName?: string
  containerClassName?: string
  showBottomPadding?: boolean
}

export function AnalyticsDashboardLayout({
  children,
  periodSelector,
  metrics,
  planVsFact,
  funnel,
  charts,
  dailyTable,
  afterTable,
  outerClassName,
  containerClassName,
  showBottomPadding = false
}: AnalyticsDashboardLayoutProps) {
  const outerClass = outerClassName || ''
  const containerClass = ['max-w-6xl mx-auto space-y-3', containerClassName].filter(Boolean).join(' ')

  if (children) {
    return (
      <div className={outerClass}>
        <div className={containerClass}>
          {children}
          {showBottomPadding && <div className="h-20"></div>}
        </div>
        {afterTable}
      </div>
    )
  }

  return (
    <div className={outerClass}>
      <div className={containerClass}>
        {periodSelector}
        {metrics}
        {planVsFact}
        {funnel}
        {charts}
        {dailyTable}
        {showBottomPadding && <div className="h-20"></div>}
      </div>
      {afterTable}
    </div>
  )
}
